/* eslint-disable */
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useLogin } from '../hooks/useLogin';
import { YES, server } from '../constants';
import sidebarConfig from '../layouts/dashboard/SidebarConfig';

export default function ProtectedRoute({ children, checkMenuPermission = false }) {
  const login = useLogin();
  const location = useLocation();

  // ดึงค่าล่าสุดจาก localStorage ทุกครั้งที่มีการ render
  const loginPassed = localStorage.getItem(server.LOGIN_PASSED) || '';

  console.log('login.expired : ', login.expired);

  // 1. ตรวจสอบสถานะ contract expired ก่อน
  if (login && login.expired === true) {
    return <Navigate to="/newpost" replace />;
  }

  // 2. ตรวจสอบว่า login ผ่านหรือไม่
  if (loginPassed !== YES && location.pathname !== '/login') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // 3. (ถ้าจำเป็น) ตรวจสอบสิทธิ์การเข้าถึงเมนู
  if (checkMenuPermission) {
    try {
      const showMenu = (localStorage.getItem(server.LOGIN_MENU) || '').split(',').filter(Boolean);
      const currentMenuItem = sidebarConfig.find(
        (item) => item && item.path && location.pathname.includes(item.path)
      );
      const menuName = currentMenuItem ? currentMenuItem.name : '';

      //   console.log(
      //     'Current Menu:',
      //     menuName,
      //     'Available Menus:',
      //     showMenu,
      //     'Location:',
      //     location.pathname,
      //     'sidebarConfig:',
      //     sidebarConfig,
      //     'currentMenuItem:',
      //     currentMenuItem
      //   );

      // ถ้าไม่มีชื่อเมนู หรือ user ไม่มีสิทธิ์ในเมนูนั้น ให้ไปที่หน้า 404
      if ((!menuName || !showMenu.includes(menuName)) && menuName !== 'newpost') {
        return <Navigate to="/404" replace />;
      }
    } catch (error) {
      console.error('Error checking menu permission:', error);
      return <Navigate to="/404" replace />;
    }
  }

  // 4. ถ้าผ่านทุกเงื่อนไข แสดงหน้าที่ต้องการ
  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  checkMenuPermission: PropTypes.bool
};
